import Store from "../store";
import tooltip from "../global/tooltip";
import formula from "../global/formula";
import server from "../controllers/server";
import { getSheetIndex } from "../methods/get";
import imageCtrl from "../controllers/imageCtrl";
import { parseDataToNumber } from "./chartUtil";
import { getObjType, replaceHtml } from "./util";
import { hasPartMC } from "../global/validate";
import { zoomChange } from "../controllers/zoom";
import { luckysheetDrawMain } from "../global/draw";
import sheetmanage from "../controllers/sheetmanage";
import { selectionCopyShow } from "../controllers/select";
import { getRangeAxis, getRangeByTxt, getSheet, getTxtByRange } from "../global/api";
import { luckysheetdefaultstyle, modelHTML } from "../controllers/constant";
import { luckysheet_searcharray } from "../controllers/sheetSearch";
import { hideAllNeedRangeShow } from "../expendPlugins/chart/plugin";
import dataVerificationCtrl from "../controllers/dataVerificationCtrl";
import luckysheetConfigsetting from "../controllers/luckysheetConfigsetting";
import { colLocation, rowLocation } from "../global/location";

/**
 * @description 打印模块相关工具类
 * @author weifeng
 * @time 20251217
 */

/**
 * @description 切换预览试图 常规模式 | 页面布局 | 分页预览
 * @param {*} curType
 * @param {*} preType
 */
function handleViewChange(curType, preType) {
    let currentSheet = sheetmanage.getSheetByIndex();

    if (currentSheet.config == null) {
        currentSheet.config = {};
    }

    if (currentSheet.config.sheetViewZoom == null) {
        currentSheet.config.sheetViewZoom = {};
    }

    let defaultZoom = 1,
        type = "zoomScaleNormal";
    if (curType == "viewNormal") {
        type = "viewNormalZoomScale";
    } else if (curType == "viewLayout") {
        type = "viewLayoutZoomScale";
    } else if (curType == "viewPage") {
        type = "viewPageZoomScale";
        defaultZoom = 0.6;
    }

    let curZoom = currentSheet.config.sheetViewZoom[type];
    if (curZoom == null) {
        curZoom = defaultZoom;
    }

    currentSheet.config.curentsheetView = curType;

    if (Store.clearjfundo) {
        Store.jfredo.push({
            type: "viewChange",
            curType: curType,
            preType: preType,
            sheetIndex: Store.currentSheetIndex,
        });
    }

    server.saveParam("cg", Store.currentSheetIndex, curType, { k: "curentsheetView" });

    Store.currentSheetView = curType;

    zoomChange(curZoom);
}

/**
 * @description 打印预览弹窗HTML
 */
function getPrevieDialogContent() {
    return `
    <div class="luckysheet-print-preview-box">
        <div class="luckysheet-print-preview-box-header"> <span>打印预览</span> <button>退出预览</button> </div>
    
        <div class="luckysheet-print-preview-container">
            <div class="luckysheet-print-preview-images">
            </div>
            <div class="luckysheet-print-preview-settings">
                <div class="luckysheet-print-preview-settings-header">
                    <span>打印设置</span>
                </div>
                <div class="luckysheet-print-preview-settings-item">
                    <label for="grid-line">网格线</label>
                    <input type="checkbox" id="grid-line" name="grid-line" checked />
                </div>
    
                <div class="luckysheet-print-preview-settings-item">
                    <label for="page-margin">页边距</label>
                    <select id="page-margin" name="page-margin">
                        <option value="0" selected>0mm</option>
                        <option value="5">5mm</option>
                        <option value="10">10mm</option>
                        <option value="15">15mm</option>
                        <option value="20">20mm</option>
                    </select>
                </div>
    
                <div class="luckysheet-print-preview-settings-item">
                    <label for="page-scale">缩放</label>
                    <input disabled type="number" id="page-scale" name="page-scale" step="0.1" min="0.1" max="5" value="1" />
                </div>
    
                <div class="luckysheet-print-preview-settings-confirm">
                    <button>确认打印</button>
                </div>
            </div>
        </div>
    </div>
    `;
}

// 获取1mm的像素
function getOneMmsPx() {
    let div = document.createElement("div");
    div.style.width = "1mm";
    document.querySelector("body").appendChild(div);
    let mm1 = div.getBoundingClientRect();
    let w = mm1.width;
    $(div).remove();
    return w;
}

/**
 * @description 获取纸张大小
 * @returns
 */
function getPaperSize() {
    // 默认A4纸张大小 210x297mm 转换为像素 - 这个值是A4纸张的像素大小，固定不变的，需要将其绑定到单元格上，跟随单元格缩放
    const paperWidth = 210 * getOneMmsPx() * Store.zoomRatio;
    // const paperWidth = 210 * Store.zoomRatio;
    const paperHeight = 297 * getOneMmsPx() * Store.zoomRatio;
    // const paperHeight = 297 * Store.zoomRatio;
    return { paperWidth, paperHeight };
}

/**
 * @description 设置图片区域，并设置宽高大小
 */
function patchImageContent($dialog, imageList) {
    // 2. 获取图片 container 容器，将 imageList 转为 img 标签
    const $images = $dialog.find(".luckysheet-print-preview-images");
    $images.html(
        imageList
            .map(
                (src) => `<div class="luckysheet-print-preview-images-item" >
                        <img src="${src}" border="0" class="print-box" />
                    </div>`,
            )
            .join(""),
    );

    // 3. 动态设置图片的宽高，使其比例始终为 A4 纸张比例,高度固定为 100%
    const a4Width = 210;
    const a4Height = 297;

    const parentHeight = $(".luckysheet-print-preview-images").height();
    const parentWidth = (a4Width / a4Height) * parentHeight;

    $images.find(".luckysheet-print-preview-images-item").css({ width: parentWidth, height: parentHeight });
}

/**
 * @description 在分页预览模式下绘制页面边界线和页码
 */
function drawPrintLineAndPaper() {
    if (Store.flowdata == null) {
        return;
    }

    let scrollWidth = $("#luckysheet-cell-main").scrollLeft();
    let scrollHeight = $("#luckysheet-cell-main").scrollTop();
    let drawWidth = Store.luckysheetTableContentHW[0];
    let drawHeight = Store.luckysheetTableContentHW[1];

    // 获取绘制区域左上角坐标
    let offsetLeft = Store.rowHeaderWidth;
    let offsetTop = Store.columnHeaderHeight;

    // 获取canvas上下文
    const luckysheetTableContent = $("#luckysheetTableContent").get(0).getContext("2d");
    luckysheetTableContent.save();
    // 保持与 drawMain 一致的缩放
    luckysheetTableContent.scale(Store.devicePixelRatio, Store.devicePixelRatio);

    const { fill_col_ed, fill_row_ed } = getFillColAndRowEnd(scrollWidth, scrollHeight, drawWidth, drawHeight);

    // 计算表格的宽高 - 可视区的宽高，并不是真实的完整的表格宽高
    const sheetWidth = fill_col_ed - scrollWidth;
    const sheetHeight = fill_row_ed - scrollHeight;

    // 必须知道全部的页码，才能正确地绘制出 第几页 的关系。
    const rowCount = Store.visibledatarow.length;
    const colCount = Store.visibledatacolumn.length;

    const { rows, columns } = getPageSplitArray(0, rowCount, 0, colCount);

    // 一行可以被分为多少页？
    const rowPageCount = columns.length;

    // 绘制水平线和页码
    for (let i = 0; i < rows.length; i++) {
        // 这个是行的 Y 值
        const row = rows[i];

        // 计算中心Y坐标用于页码显示
        const currentY = row.y;
        const prevY = i > 0 ? rows[i - 1].y : 0;
        const centerY = currentY - (currentY - prevY) / 2 - scrollHeight;

        // 绘制水平线
        drawPrintLine(luckysheetTableContent, offsetLeft, row.y - scrollHeight + offsetTop, sheetWidth + offsetLeft, row.y - scrollHeight + offsetTop);

        // 绘制垂直线和页码
        for (let j = 0; j < columns.length; j++) {
            // 计算中心X坐标用于页码显示
            const col = columns[j];
            const currentX = col.x;
            const prevX = j > 0 ? columns[j - 1].x : 0;
            const centerX = currentX - (currentX - prevX) / 2 - scrollWidth + offsetLeft;

            // 绘制垂直线
            drawPrintLine(luckysheetTableContent, col.x - scrollWidth + offsetLeft, offsetTop, col.x - scrollWidth + offsetLeft, sheetHeight + offsetTop);

            // 绘制页码
            drawPageNumbers(luckysheetTableContent, centerX, centerY, i * rowPageCount + j + 1);
        }
    }

    // 恢复canvas状态
    luckysheetTableContent.restore();
}

/**
 * @description 辅助函数 - 获取起始和结束行列坐标
 * @param {Number} scrollWidth - 水平滚动距离
 * @param {Number} scrollHeight - 垂直滚动距离
 * @param {Number} drawWidth - 绘制区域宽度
 * @param {Number} drawHeight - 绘制区域高度
 * @returns {Object} 包含行列坐标的对象
 */
function getFillColAndRowEnd(scrollWidth, scrollHeight, drawWidth, drawHeight) {
    let columnOffsetCell = 0;
    let rowOffsetCell = 0;

    // 表格渲染区域起止行列下标
    let dataset_row_st, dataset_row_ed, dataset_col_st, dataset_col_ed;

    dataset_row_st = luckysheet_searcharray(Store.visibledatarow, scrollHeight);
    dataset_row_ed = luckysheet_searcharray(Store.visibledatarow, scrollHeight + drawHeight);

    if (dataset_row_st == -1) {
        dataset_row_st = 0;
    }

    dataset_row_st += rowOffsetCell;

    if (dataset_row_ed == -1) {
        dataset_row_ed = Store.visibledatarow.length - 1;
    }

    dataset_row_ed += rowOffsetCell;

    if (dataset_row_ed >= Store.visibledatarow.length) {
        dataset_row_ed = Store.visibledatarow.length - 1;
    }

    dataset_col_st = luckysheet_searcharray(Store.visibledatacolumn, scrollWidth);
    dataset_col_ed = luckysheet_searcharray(Store.visibledatacolumn, scrollWidth + drawWidth);

    if (dataset_col_st == -1) {
        dataset_col_st = 0;
    }

    dataset_col_st += columnOffsetCell;

    if (dataset_col_ed == -1) {
        dataset_col_ed = Store.visibledatacolumn.length - 1;
    }

    dataset_col_ed += columnOffsetCell;

    if (dataset_col_ed >= Store.visibledatacolumn.length) {
        dataset_col_ed = Store.visibledatacolumn.length - 1;
    }

    // 表格渲染区域起止行列坐标
    let fill_row_st, fill_row_ed, fill_col_st, fill_col_ed;

    if (dataset_row_st == 0) {
        fill_row_st = 0;
    } else {
        fill_row_st = Store.visibledatarow[dataset_row_st - 1];
    }
    fill_row_ed = Store.visibledatarow[dataset_row_ed];

    if (dataset_col_st == 0) {
        fill_col_st = 0;
    } else {
        fill_col_st = Store.visibledatacolumn[dataset_col_st - 1];
    }
    fill_col_ed = Store.visibledatacolumn[dataset_col_ed];

    return { dataset_row_st, dataset_row_ed, dataset_col_st, dataset_col_ed, fill_col_ed, fill_row_ed };
}

/**
 * @description 对传入的起始结束行列进行页码分割，返回分割后的行列数据
 * 	1. 目前设计的思路是 A4 尺寸页码大小需要附和到上一个单元格上，保证一个单元格被完整打印
 *  2. 如果不包含结束行列，则需要手动添加
 * @param { number } startRow
 * @param { number } endRow
 * @param { number } startColumn
 * @param { number } endColumn
 * @returns
 */
function getPageSplitArray(startRow = 0, endRow, startColumn = 0, endColumn) {
    let rows = [];
    let columns = [];

    const { paperWidth, paperHeight } = getPaperSize();

    // 这里是循环当前行一共可分为多少页
    for (let r = startRow; r < endRow; r++) {
        // 如果行被隐藏了 则跳过
        if (Store.config["rowhidden"] != null && Store.config["rowhidden"][r] != null) continue;

        // 当前行的 Y 坐标 - 真实的 y 坐标，与可视区无关
        let current_end_y = Store.visibledatarow[r];

        // 前一行的 Y 坐标 - 真实的 y 坐标，与可视区无关
        let prev_end_y = r > 0 ? Store.visibledatarow[r - 1] : 0;

        // 计算相对于前一个分页线的坐标
        let relativeCurrentY = current_end_y;
        let relativePrevY = prev_end_y;

        // 如果已经有分页线，则基于上一个分页线计算相对位置
        if (rows.length > 0) {
            let lastPageBreak = rows[rows.length - 1].rowIndex;
            let lastPageBreakY = Store.visibledatarow[lastPageBreak];
            relativeCurrentY = current_end_y - lastPageBreakY;
            relativePrevY = prev_end_y - lastPageBreakY;
        }

        // 计算当前行属于第几个页面（基于页面高度的倍数）
        let currentPageIndex = Math.floor(relativeCurrentY / paperHeight);

        // 计算前一行属于第几个页面
        let prevPageIndex = Math.floor(relativePrevY / paperHeight);

        // 如果当前行和前一行属于不同的页面，说明当前行是新页面的开始行
        if (currentPageIndex > prevPageIndex) {
            rows.push({
                rowIndex: r,
                y: current_end_y,
                h: current_end_y - (rows[rows.length - 1] ? rows[rows.length - 1].y : 0),
            });
        }
    }

    // 循环所有列
    for (let c = startColumn; c < endColumn; c++) {
        // 如果列被隐藏了 则跳过
        if (Store.config && Store.config["colhidden"] != null && Store.config["colhidden"][c] != null) continue;

        // 当前列的 X 坐标 - 真实的 x 坐标，与可视区无关
        let current_end_x = Store.visibledatacolumn[c];

        // 前一列的 X 坐标 - 真实的 x 坐标，与可视区无关
        let prev_end_x = c > 0 ? Store.visibledatacolumn[c - 1] : 0;

        // 计算相对于前一个分页线的坐标
        let relativeCurrentX = current_end_x;
        let relativePrevX = prev_end_x;

        // 如果已经有分页线，则基于上一个分页线计算相对位置
        if (columns.length > 0) {
            let lastPageBreak = columns[columns.length - 1].colIndex;
            let lastPageBreakX = Store.visibledatacolumn[lastPageBreak];
            relativeCurrentX = current_end_x - lastPageBreakX;
            relativePrevX = prev_end_x - lastPageBreakX;
        }

        // 计算当前列属于第几个页面（基于页面宽度的倍数）
        let currentPageIndex = Math.floor(relativeCurrentX / paperWidth);

        // 计算前一列属于第几个页面
        let prevPageIndex = Math.floor(relativePrevX / paperWidth);

        // 如果当前列和前一列属于不同的页面，说明当前列是新页面的开始列
        if (currentPageIndex > prevPageIndex) {
            columns.push({
                colIndex: c,
                x: current_end_x,
                w: current_end_x - (columns[columns.length - 1] ? columns[columns.length - 1].x : 0),
            });
        }
    }

    // 处理结束行列
    if (!rows.find((r) => r.rowIndex === endRow)) {
        const current_end_y = Store.visibledatarow[endRow - 1];
        rows.push({
            rowIndex: endRow,
            y: current_end_y,
            h: current_end_y - (rows[rows.length - 1] ? rows[rows.length - 1].y : 0),
        });
    }

    if (!columns.find((c) => c.colIndex === endColumn)) {
        const current_end_x = Store.visibledatacolumn[endColumn - 1];
        columns.push({
            colIndex: endColumn,
            x: current_end_x,
            w: current_end_x - (columns[columns.length - 1] ? columns[columns.length - 1].x : 0),
        });
    }

    return { rows, columns };
}

/**
 * @description 辅助函数 - 绘制打印页码，实现水平垂直居中显示"第几页"
 * @param {CanvasRenderingContext2D} ctx - Canvas绘图上下文
 * @param {Number} x - 绘制的X坐标
 * @param {Number} y - 绘制的Y坐标
 * @param {Number} pageNum - 页码
 * @param {String} [font="18px Arial"] - 字体样式
 * @param {String} [fillStyle="#55bb8a"] - 填充颜色
 */
function drawPageNumbers(ctx, x, y, pageNum, font = "18px Arial", fillStyle = "#55bb8a") {
    ctx.save();
    ctx.font = font;
    ctx.fillStyle = fillStyle;

    const text = `第${pageNum}页`;
    // 获取文本宽度
    const textWidth = getTextWidth(ctx, text);
    // 获取文本高度
    const textHeight = getTextHeight(ctx, text);
    ctx.fillText(text, x - textWidth / 2, y + textHeight / 2);
    ctx.restore();
}

/**
 * @description 辅助函数 - 绘制打印线
 * @param {CanvasRenderingContext2D} ctx - Canvas绘图上下文
 * @param {Number} startX - 起始X坐标
 * @param {Number} startY - 起始Y坐标
 * @param {Number} endX - 结束X坐标
 * @param {Number} endY - 结束Y坐标
 * @param {Number} [lineWidth=1] - 线宽
 * @param {String} [strokeStyle="#55bb8a"] - 线颜色
 * @param {Array} [lineDash=[10, 6]] - 虚线样式
 * */
function drawPrintLine(ctx, startX, startY, endX, endY, lineWidth = 1, strokeStyle = "#55bb8a", lineDash = [10, 6]) {
    ctx.save();
    ctx.beginPath();
    ctx.strokeStyle = strokeStyle;
    ctx.lineWidth = lineWidth;
    ctx.setLineDash(lineDash);
    ctx.moveTo(startX, startY);
    ctx.lineTo(endX, endY);
    ctx.stroke();
    ctx.closePath();
    ctx.restore();
}

/**
 * @description 工具函数 - 计算文本宽度
 */
function getTextWidth(ctx, text) {
    return ctx.measureText(text).width;
}

/**
 * @description 工具函数 - 计算文本高度
 */
function getTextHeight(ctx, text) {
    const metrics = ctx.measureText(text);
    return metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent;
}

/**
 * @description 工具函数 - 唤起单元格选择器
 * @param {Array} defaultRange - 初始化选区
 * @param { Function } callback - 回调函数
 */
function openSelection(defaultRange, callback) {
    const _this = dataVerificationCtrl;

    // 这个文本默认为当前用户的选区
    const defaultRangeArray = getRangeAxis();
    // 打印只支持单个选区 - 默认最后一个选区
    const currentRange = defaultRangeArray[defaultRangeArray.length - 1];
    let txt = currentRange;

    // 如果用户传递了选区参数，则使用用户的参数选区
    if (defaultRange) {
        if (getObjType(defaultRange) == "string") {
            if (!formula.iscelldata(defaultRange)) {
                return tooltip.info("The range parameter is invalid.", "");
            }
            txt = defaultRange;
        } else if (getObjType(defaultRange) == "object" && defaultRange.row !== null && defaultRange.column !== null) {
            // 用户传入的是对象 range = { row:[1,2],comlumn:[1,2] }，需要转换为文本格式
            txt = getTxtByRange(defaultRange);
        } else return tooltip.info("The range parameter is invalid.", "");
    }

    // 唤起单元格选择器
    _this.rangeDialog(null, txt);

    _this.selectRange = [];

    let range = _this.getRangeByTxt(txt);

    formula.rangetosheet = Store.currentSheetIndex;

    if (range[0].sheetIndex != Store.currentSheetIndex) {
        sheetmanage.changeSheetExec(range[0].sheetIndex);
    }

    if (range.length > 0) {
        for (let s = 0; s < range.length; s++) {
            let r1 = range[s].row[0],
                r2 = range[s].row[1];
            let c1 = range[s].column[0],
                c2 = range[s].column[1];

            let row = Store.visibledatarow[r2],
                row_pre = r1 - 1 == -1 ? 0 : Store.visibledatarow[r1 - 1];
            let col = Store.visibledatacolumn[c2],
                col_pre = c1 - 1 == -1 ? 0 : Store.visibledatacolumn[c1 - 1];

            _this.selectRange.push({
                left: col_pre,
                width: col - col_pre - 1,
                top: row_pre,
                height: row - row_pre - 1,
                left_move: col_pre,
                width_move: col - col_pre - 1,
                top_move: row_pre,
                height_move: row - row_pre - 1,
                row: [r1, r2],
                column: [c1, c2],
                row_focus: r1,
                column_focus: c1,
            });
        }
    }

    selectionCopyShow(_this.selectRange);

    // 确认按钮
    $(document)
        .off("click.dvRangeConfirm")
        .on("click.dvRangeConfirm", "#luckysheet-dataVerificationRange-dialog-confirm", function (e) {
            // 当前选定的选区为
            const range = $(this).parents("#luckysheet-dataVerificationRange-dialog").find("input").val();
            // 通过回调实现选区传递
            if (callback && typeof callback === "function") callback({ range });
            closeSelection();
        });

    // 关闭按钮
    $(document).off("click.dvRangeClose").on("click.dvRangeClose", "#luckysheet-dataVerificationRange-dialog-close", closeSelection);

    // 模态框关闭
    $(document).on("click", "#luckysheet-dataVerificationRange-dialog .luckysheet-modal-dialog-title-close", closeSelection);
}

/**
 * @description 工具函数 - 关闭选区，并清空选区数据
 */
function closeSelection() {
    $("#luckysheet-dataVerificationRange-dialog").hide();
    $("#luckysheet-modal-dialog-mask").hide();
    selectionCopyShow([]);
}

/**
 * @description 对传入的选区进行打印页面纸张计算
 * @param {String} range 选区 - "A3:H8" | "A3"
 * @returns {Array} - 计算后的选区范围 ['A3:B4','B4:H8'] | [ {  } ]
 */
function calculatePageRanges(range) {
    // 解析范围字符串，例如"A3:H8"
    const rangeParts = range.split(":");

    if (rangeParts.length !== 2) {
        return [range];
    }

    // 使用 API 实现单元格字符串与对象的转换
    const startCell = getRangeByTxt(rangeParts[0]);
    const endCell = getRangeByTxt(rangeParts[1]);

    const startRow = startCell.row[0];
    const startCol = startCell.column[0];
    const endRow = endCell.row[1] + 1; // 这里 + 1 是为了计算
    const endCol = endCell.column[1] + 1;

    /**
     * 重要函数说明：
     * 在此函数处理中，应该是获取单元格的宽高进行累加，而不是使用 y x 进行累加
     * 不然会出现：如果截取单元格位于分割线两边，则会被分成两个打印区域
     * 这里返回的直接是 rows 和 columns 行列索引
     */

    const { rows, columns } = justifyPageRange(startRow, endRow, startCol, endCol);

    const pageRanges = [];

    // 根据分页的行和列索引，拼接完整的页面范围
    for (let i = 0; i < rows.length - 1; i++) {
        for (let j = 0; j < columns.length - 1; j++) {
            // 当前页面的起始和结束行列索引
            const startR = rows[i];
            const endR = rows[i + 1] - 1; // 这里 - 1 是为了还原前面的 + 1
            const startC = columns[j];
            const endC = columns[j + 1] - 1;

            pageRanges.push({
                row: [startR, endR],
                column: [startC, endC],
            });
        }
    }

    return pageRanges;
}

/**
 * @description 针对指定选区打印时，需要判定当前传入的选区是否满足页面纸张尺寸要求
 * @param { Number } startRow 始行索引
 * @param { Number } endRow 终行索引
 * @param { Number } startCol 始列索引
 * @param { Number } endCol 终列索引
 * @returns { row: [number], column: [number] }
 */
function justifyPageRange(startRow, endRow, startCol, endCol) {
    // 请注意：这里的实现思路与上页面绘制分割线及页面序号类似，但是，本函数内，是通过累加其宽高，实现真实的宽高对比，而非直接取单元格的 x y

    // 这里存储的就是打印区域分割的 行列索引
    let rows = [startRow];
    let columns = [startCol];

    const { paperWidth, paperHeight } = getPaperSize();

    let sumWidth = 0;
    let sumHeight = 0;

    // 这里是循环当前行一共可分为多少页
    for (let r = startRow; r <= endRow; r++) {
        // 累加其真实的宽度
        // 如果行被隐藏了 则跳过
        if (Store.config["rowhidden"] != null && Store.config["rowhidden"][r] != null) continue;
        // 当前单元格的高度
        const rowHeight = Store.visibledatarow[r] - Store.visibledatarow?.[r - 1] || 0;

        // 如果当前高度累加，已经高于页面高度，则应该在当前单元格中断，进行分页操作
        if (sumHeight + rowHeight > paperHeight) {
            rows.push(r);
            sumHeight = 0;
        }
        sumHeight += rowHeight;
    }

    // 这里是循环当前列一共可分为多少页
    for (let c = startCol; c <= endCol; c++) {
        // 累加其真实的高度
        // 如果列被隐藏了 则跳过
        if (Store.config["colhidden"] != null && Store.config["colhidden"][c] != null) continue;
        // 同上
        const colWidth = Store.visibledatacolumn[c] - Store.visibledatacolumn?.[c - 1] || 0;
        if (sumWidth + colWidth > paperWidth) {
            columns.push(c);
            sumWidth = 0;
        }
        sumWidth += colWidth;
    }

    // 判定是否包含了结束行列
    if (rows[rows.length - 1] != endRow) {
        rows.push(endRow);
    }
    if (columns[columns.length - 1] != endCol) {
        columns.push(endCol);
    }

    return { rows, columns };
}

/**
 * @description 打印当前sheet页时，需要判定当前sheet页有值的单元格
 */
function justifySheetValueRange() {
    console.log("justifySheetValueRange");

    let range = {
        startRow: 0,
        endRow: 0,
        startCol: 0,
        endCol: 0,
    };

    // 1. celldata 中的单元格都需要打印，但是需要注意，有些没有值的单元格，但是设定了字体颜色，这种场景下，可自行处理是否需要打印
    justifySheetCellData(range);

    // 2. 合并单元格需要打印
    justifySheetMerge(range);

    // 3. 边框单元格需要打印
    justifySheetBorder(range);

    // 4. 浮动图片需要检测范围
    justifySheetImage(range);

    // 5. 统计图表需要检测范围 - 请一定确保统计图最后判定
    justifySheetChart(range);

    // 6. 如果当前sheet页为空，则需要默认初始化一张A4范围的页面

    return range;
}

function justifySheetCellData(range) {
    // 需要明确传递当前 sheetIndex
    const { celldata } = getSheet();

    // 循环当前 celldata 直接取 r c 进行最大值最小值比较即可
    for (let i = 0; i < celldata.length; i++) {
        const item = celldata[i];
        const { r, c, v } = item;

        // 这里判定下是否为空单元格,并非所有单元格都需要打印
        // 20260520 这里列举一些简单的场景 m v bg mc
        const patchKeys = ["m", "v", "bg", "mc"];

        // 如果 ite.v 没有 patchKeys 的健，则认为该单元格不需要打印
        if (!patchKeys.some((key) => v[key])) continue;

        range.startRow = Math.min(range.startRow, r);
        range.endRow = Math.max(range.endRow, r);
        range.startCol = Math.min(range.startCol, c);
        range.endCol = Math.max(range.endCol, c);
    }
}
function justifySheetImage(range) {
    const { images } = getSheet();
    // 单元格图片本就在 celldata 中，不需要单独处理
    if (!images || !Object.keys(images).length) return;

    //图片 active/cropping，需要先取消，不然处理截图报错
    if ($("#luckysheet-modal-dialog-activeImage").is(":visible") || $("#luckysheet-modal-dialog-cropping").is(":visible")) {
        imageCtrl.cancelActiveImgItem();
    }

    for (const key in images) {
        if (!Object.hasOwn(images, key)) continue;

        const image = images[key];
        if (image.inCell) continue;

        // 不然就获取图片的坐标，并将其转换为真实的单元格坐标
        const { left, top } = getImageRealPosition(key);
        const { width, height } = getImageRealWH(key);
        const { startRow, startCol, endRow, endCol } = getCellRangeByLeftTopWidthHeight(left, top, width, height);
        range.startRow = Math.min(range.startRow, startRow);
        range.endRow = Math.max(range.endRow, endRow);
        range.startCol = Math.min(range.startCol, startCol);
        range.endCol = Math.max(range.endCol, endCol);
    }
}
function justifySheetChart(range) {
    const { chart } = getSheet();
    if (!chart || !chart.length) return;

    // 隐藏图表选中，需要先取消，不然处理截图报错
    hideAllNeedRangeShow();

    // 循环处理
    for (let i = 0; i < chart.length; i++) {
        const { chart_id } = chart[i];
        if (!chart_id) continue;

        // 获取当前起始行列的偏移量
        const [scrollWidth] = rowLocation(range.startRow);
        const [scrollHeight] = colLocation(range.startCol);

        // 这里的单位不一定就是数值型，需要做转换
        let { left, top, width, height } = chart[i];
        left = parseDataToNumber(left) - scrollWidth;
        top = parseDataToNumber(top) - scrollHeight;
        width = parseDataToNumber(width);
        height = parseDataToNumber(height);

        // 同上
        const { startRow, startCol, endRow, endCol } = getCellRangeByLeftTopWidthHeight(left, top, width, height);
        range.startRow = Math.min(range.startRow, startRow);
        range.endRow = Math.max(range.endRow, endRow);
        range.startCol = Math.min(range.startCol, startCol);
        range.endCol = Math.max(range.endCol, endCol);
    }
}
function justifySheetBorder(range) {
    const { borderInfo } = getSheet().config; // Array

    // 如果没有边框信息，直接返回
    if (!borderInfo || !borderInfo.length) {
        return;
    }

    let { startRow, endRow, startCol, endCol } = range;

    // 遍历边框信息，计算实际的边界
    for (let i = 0; i < borderInfo.length; i++) {
        const border = borderInfo[i];
        const rangeType = border.rangeType;

        if (rangeType === "range" && border.range) {
            // 处理范围类型的边框
            for (let j = 0; j < border.range.length; j++) {
                const range = border.range[j];
                const r1 = range.row[0]; // 起始行
                const r2 = range.row[1]; // 结束行
                const c1 = range.column[0]; // 起始列
                const c2 = range.column[1]; // 结束列

                // 更新边界值
                startRow = Math.min(startRow, r1);
                endRow = Math.max(endRow, r2);
                startCol = Math.min(startCol, c1);
                endCol = Math.max(endCol, c2);
            }
        } else if (rangeType === "cell" && border.value) {
            // 处理单元格类型的边框
            const value = border.value;
            const r = value.row_index;
            const c = value.col_index;

            // 更新边界值
            startRow = Math.min(startRow, r);
            endRow = Math.max(endRow, r);
            startCol = Math.min(startCol, c);
            endCol = Math.max(endCol, c);
        }
    }

    // 修改传入对象的属性
    range.startRow = startRow;
    range.endRow = endRow;
    range.startCol = startCol;
    range.endCol = endCol;
}
function justifySheetMerge(range) {
    const { merge } = getSheet().config; // Object
    // "13_5": { "r": 13, "c": 5, "rs": 3, "cs": 1 },

    // 如果没有合并单元格信息，直接返回
    if (!merge || !Object.keys(merge).length) {
        return;
    }

    let { startRow, endRow, startCol, endCol } = range;

    // 遍历合并单元格信息，计算实际的边界
    for (const key in merge) {
        const mergedCell = merge[key];
        const r = mergedCell.r; // 起始行
        const c = mergedCell.c; // 起始列
        const rs = mergedCell.rs; // 行跨度
        const cs = mergedCell.cs; // 列跨度

        // 计算合并单元格的实际结束行列
        const mergeEndRow = r + rs - 1;
        const mergeEndCol = c + cs - 1;

        // 更新边界值
        startRow = Math.min(startRow, r);
        endRow = Math.max(endRow, mergeEndRow);
        startCol = Math.min(startCol, c);
        endCol = Math.max(endCol, mergeEndCol);
    }

    // 修改传入对象的属性
    range.startRow = startRow;
    range.endRow = endRow;
    range.startCol = startCol;
    range.endCol = endCol;

    console.log("justifySheetMerge", range);
}

/**
 * @description 对传入的 left top width height 范围，获取对应的单元格范围
 * @param { number } left
 * @param { number } top
 * @param { number } width
 * @param { number } height
 * @returns { object = { startRow, endRow, startCol, endCol } }
 */
function getCellRangeByLeftTopWidthHeight(left, top, width, height) {
    const { visibledatarow, visibledatacolumn } = Store;

    // 查找起始和结束的行列索引
    let startRow = luckysheet_searcharray(visibledatarow, top);
    let endRow = luckysheet_searcharray(visibledatarow, top + height);
    let startCol = luckysheet_searcharray(visibledatacolumn, left);
    let endCol = luckysheet_searcharray(visibledatacolumn, left + width);

    // 处理边界情况
    if (startRow == -1) {
        startRow = 0;
    }
    if (endRow == -1) {
        endRow = visibledatarow.length - 1;
    } else {
        // 如果找到了确切的行，需要检查是否正好在边界上，如果不是则需要加一
        if (visibledatarow[endRow] <= top + height) {
            endRow++;
        }
    }
    if (startCol == -1) {
        startCol = 0;
    }
    if (endCol == -1) {
        endCol = visibledatacolumn.length - 1;
    } else {
        // 如果找到了确切的列，需要检查是否正好在边界上，如果不是则需要加一
        if (visibledatacolumn[endCol] <= left + width) {
            endCol++;
        }
    }

    return { startRow, endRow, startCol, endCol };
}

/**
 * @description 获取当前页面的截图
 * @param {*} options
 * @param {boolean} printGridLine 是否打印表格线
 * @returns
 */
async function getScreenshotBySheet() {
    let { startRow, endRow, startCol, endCol } = justifySheetValueRange();
    endRow++;
    endCol++;

    const { rows, columns } = justifyPageRange(startRow, endRow, startCol, endCol);

    const pageRanges = [];

    // 根据分页的行和列索引，拼接完整的页面范围
    for (let i = 0; i < rows.length - 1; i++) {
        for (let j = 0; j < columns.length - 1; j++) {
            // 当前页面的起始和结束行列索引
            const startR = rows[i];
            const endR = rows[i + 1] - 1; // 这里 - 1 是为了还原前面的 + 1
            const startC = columns[j];
            const endC = columns[j + 1] - 1;

            pageRanges.push({
                row: [startR, endR],
                column: [startC, endC],
            });
        }
    }

    console.log("pageRanges", pageRanges);

    return Promise.resolve(pageRanges);
}

/**
 * @description 截取指定单元格页面
 * @param { range: string | {rows:{},columns:{}}} options
 * @param {boolean} printGridLine 是否打印表格线
 * @param {object | string} range 截取的范围
 * @returns
 */
async function getScreenshotByRange(options = {}) {
    let { range = Store.luckysheet_select_save[Store.luckysheet_select_save.length - 1], printGridLine = true } = { ...options };
    console.log("传入的 range", range);
    if (getObjType(range) == "string") {
        if (!formula.iscelldata(range)) {
            return tooltip.info("The range parameter is invalid.", "");
        }

        let cellrange = formula.getcellrange(range);
        range = {
            row: cellrange.row,
            column: cellrange.column,
        };
    }

    if (getObjType(range) != "object" || range.row == null || range.column == null) {
        return tooltip.info("The range parameter is invalid.", "");
    }

    let str = range.row[0],
        edr = range.row[1],
        stc = range.column[0],
        edc = range.column[1];

    let has_PartMC = hasPartMC(Store.config, str, edr, stc, edc);

    if (has_PartMC) {
        return tooltip.info("Cannot perform this operation on partially merged cells", "");
    }

    let visibledatarow = Store.visibledatarow;
    let visibledatacolumn = Store.visibledatacolumn;

    let scrollHeight, rh_height;
    if (str - 1 < 0) {
        scrollHeight = 0;
        rh_height = visibledatarow[edr];
    } else {
        scrollHeight = visibledatarow[str - 1];
        rh_height = visibledatarow[edr] - visibledatarow[str - 1];
    }

    let scrollWidth, ch_width;
    if (stc - 1 < 0) {
        scrollWidth = 0;
        ch_width = visibledatacolumn[edc];
    } else {
        scrollWidth = visibledatacolumn[stc - 1];
        ch_width = visibledatacolumn[edc] - visibledatacolumn[stc - 1];
    }

    // 进行后续的操纵
    return await handleScreenshot(scrollWidth, scrollHeight, ch_width, rh_height, printGridLine);
}

/**
 * @description 截取指定页面
 * @param {*} options
 * @param {boolean} printGridLine 是否打印表格线
 * @param {number} pageNum 页码
 * @returns
 */
async function getScreenshotByPageNum(options = {}) {
    let { pageNum = 1, printGridLine = true } = { ...options };

    if (!pageNum || pageNum < 1) return;

    // 请注意,每一个的宽高不一定相等,因为设计为跟随单元格了,而不是固定的 210mm,如果设定为 固定的话,所有的处理将非常简单
    let ch_width = 0;
    let rh_height = 0;
    let scrollWidth = 0;
    let scrollHeight = 0;

    // 当前的总行数
    const rowCount = Store.visibledatarow.length;
    const colCount = Store.visibledatacolumn.length;

    const { rows, columns } = getPageSplitArray(0, rowCount, 0, colCount);
    let findSuccess = false;

    //  一行可以被分为多少页？
    const rowPageCount = columns.length;
    // 则每新增一行，都以 rowPageCount 为倍数递增即可
    for (let i = 0; i < rows.length; i++) {
        if (findSuccess) break;

        for (let j = 0; j < columns.length; j++) {
            if (findSuccess) break;

            const currentPage = i * rowPageCount + j + 1;
            if (pageNum === currentPage) {
                // 计算宽高
                ch_width = columns[j].w;
                rh_height = rows[i].h;
                scrollWidth = columns[j].x - ch_width;
                scrollHeight = rows[i].y - rh_height;
                findSuccess = true;
            }
        }
    }

    // 没有找到该页码，请重试！
    if (!findSuccess) {
        console.warn(`没有找到 ${pageNum} 页码，请重试！`);
        tooltip.info(`没有找到 ${pageNum} 页码，请重试！`, "");
        return null;
    }

    // 进行后续的操纵
    return await handleScreenshot(scrollWidth, scrollHeight, ch_width, rh_height, printGridLine);
}

/**
 * @description 截图的后续处理工作
 *  1. 进行 drawMain 绘制主内容区
 *  2. 补上边框和上边框
 *  3. 进行 统计图表 绘制 - 注意层级关系
 *  4. 进行图片绘制 - 注意层级关系
 *  5. 进行水印优化
 */
async function handleScreenshot(scrollWidth, scrollHeight, ch_width, rh_height, printGridLine = true) {
    // 取用户传递的 打印像素比
    const devicePixelRatio = luckysheetConfigsetting.printDevicePixelRatio || Store.devicePixelRatio;

    let newCanvas = $("<canvas>")
        .attr({
            width: Math.ceil(ch_width * devicePixelRatio),
            height: Math.ceil(rh_height * devicePixelRatio),
        })
        .css({ width: ch_width, height: rh_height });

    luckysheetDrawMain({
        scrollWidth,
        scrollHeight,
        drawWidth: ch_width,
        drawHeight: rh_height,
        canvas: newCanvas,
        devicePixelRatio,
        offsetLeft: 1,
        offsetTop: 1,
        printGridLine,
        isPrint: true,
    });
    let ctx_newCanvas = newCanvas.get(0).getContext("2d");

    // 如果需要打印网格线，才补齐左边框和上边框
    // printGridLine && drawLineLeftAndTop(ctx_newCanvas, ch_width, rh_height, devicePixelRatio);

    // 补齐统计图
    await printChart(ctx_newCanvas, scrollWidth, scrollHeight, ch_width, rh_height, devicePixelRatio);

    // 补齐图片
    await printImage(ctx_newCanvas, scrollWidth, scrollHeight, ch_width, rh_height, devicePixelRatio);

    // 后续优化：针对不够宽的图片进行补全
    return newCanvas.get(0).toDataURL("image/png");
}

/**
 * @description 补上左边框和上边框
 * @param {*} ctx_newCanvas
 * @param {*} ch_width
 * @param {*} rh_height
 * @param {*} devicePixelRatio
 */
function drawLineLeftAndTop(ctx_newCanvas, ch_width, rh_height, devicePixelRatio) {
    ctx_newCanvas.beginPath();
    ctx_newCanvas.moveTo(0, 0);
    ctx_newCanvas.lineTo(0, devicePixelRatio * rh_height);
    ctx_newCanvas.lineWidth = devicePixelRatio * 2;
    ctx_newCanvas.strokeStyle = luckysheetdefaultstyle.strokeStyle;
    ctx_newCanvas.stroke();
    ctx_newCanvas.closePath();

    ctx_newCanvas.beginPath();
    ctx_newCanvas.moveTo(0, 0);
    ctx_newCanvas.lineTo(devicePixelRatio * ch_width, 0);
    ctx_newCanvas.lineWidth = devicePixelRatio * 2;
    ctx_newCanvas.strokeStyle = luckysheetdefaultstyle.strokeStyle;
    ctx_newCanvas.stroke();
    ctx_newCanvas.closePath();
}

/**
 * @description 绘制统计图
 * @param {*} ctx
 * @param {*} scrollWidth
 * @param {*} scrollHeight
 * @param {*} ch_width
 * @param {*} rh_height
 * @param {*} devicePixelRatio
 */
async function printChart(ctx, scrollWidth, scrollHeight, ch_width, rh_height, devicePixelRatio) {
    // 获取当前表的图表列表，判断其是否在渲染区域内
    let charts = Store.luckysheetfile[getSheetIndex(Store.currentSheetIndex)]?.chart || {};
    if (!charts || !charts.length) return;

    // 隐藏图表选中，需要先取消，不然处理截图报错
    hideAllNeedRangeShow();

    // 创建一个Promise数组来处理所有统计图的异步加载
    const chartPromises = [];

    // 循环处理
    for (let i = 0; i < charts.length; i++) {
        const { chart_id } = charts[i];
        if (!chart_id) continue;

        // 这里的单位不一定就是数值型，需要做转换
        let { left, top, width, height } = charts[i];
        left = parseDataToNumber(left) - scrollWidth;
        top = parseDataToNumber(top) - scrollHeight;
        width = parseDataToNumber(width);
        height = parseDataToNumber(height);

        // 判断当前图表是否处于打印范围
        if (!inPrintArea({ left, top, width, height, rh_height, ch_width })) continue;

        // 1. 处理统计图表
        const handleChartPromise = (resolve) => {
            // 统计图表处理原理：不管是 chartmix 还是 vchart，底层肯定是 canvas 绘制的，luckysheet 进行了外层包装，因此，直接获取底层 canvas 进行 toDataURL 即可
            const chart_box = $(`#${chart_id}_c`);
            if (!chart_box.length) resolve();

            const chart_canvas = chart_box.find("canvas").get(0);
            if (!chart_canvas) resolve();

            // [方案一：直接绘制 canvas 到 ctx 上，但是此方法不能实现边框 背景等其他效果]
            ctx.save();
            ctx.scale(devicePixelRatio, devicePixelRatio);

            // 这些值理论上不可修改，这里直接定义，如果后期需要修改，请动态获取
            const padding = [20, 10];
            const backgroundColor = "#fff";
            const borderRadius = 10; // 这个是实现圆角矩形的，这里暂不实现

            ctx.fillStyle = backgroundColor;
            ctx.fillRect(left, top, width, height); // 绘制圆角矩形有BUG，用矩形代替
            ctx.drawImage(chart_canvas, left + padding[1], top + padding[0], width - 2 * padding[1], height - 2 * padding[0]);
            ctx.restore();
            resolve();
        };

        // 2. 创建异步函数
        const chartPromise = new Promise(handleChartPromise);

        // 3. 添加到Promise数组中
        chartPromises.push(chartPromise);
    }

    return await Promise.all(chartPromises);
}

/**
 * @description 打印图片
 * @param {*} ctx
 * @param {*} scrollWidth
 * @param {*} scrollHeight
 * @param {*} ch_width
 * @param {*} rh_height
 * @param {*} devicePixelRatio
 */
async function printImage(ctx, scrollWidth, scrollHeight, ch_width, rh_height, devicePixelRatio) {
    // 获取当前表的图片列表，判断其是否在渲染区域内
    let imageList = Store.luckysheetfile[getSheetIndex(Store.currentSheetIndex)]?.images || {};
    if (!imageList || !Object.keys(imageList).length) return Promise.resolve();

    //图片 active/cropping，需要先取消，不然处理截图报错
    if ($("#luckysheet-modal-dialog-activeImage").is(":visible") || $("#luckysheet-modal-dialog-cropping").is(":visible")) {
        imageCtrl.cancelActiveImgItem();
    }

    // 创建一个Promise数组来处理所有图片的异步加载
    const imagePromises = [];

    let offsetLeft = Store.rowHeaderWidth;
    let offsetTop = Store.columnHeaderHeight;

    // 循环处理
    for (const imageID in imageList) {
        if (!Object.hasOwn(imageList, imageID)) continue;

        const image = imageList[imageID];
        if (!image) continue;

        // 请注意：单元格图片本就是绘制到 drawMain 画布上的，因此，不需要单独处理
        if (image.inCell) continue; // 这里是防止单元格图片重复打印

        // 解析图片必要参数
        const { src, crop, isFixedPos, fixedLeft, fixedTop, border } = image;

        // 当前图片可能有裁剪，故而其真实宽高可能会改变
        const { width, height } = getImageRealWH(imageID);
        // console.log("当前图片的真实宽高:", width, height);
        const { left, top } = getImageRealPosition(imageID);
        // console.log("当前图片的真实位置:", left, top);

        // 定义当前图片的相关信息，如果当前图片是固定位置模式，则其位置可能会改变
        let imageLeft = left - scrollWidth,
            imageTop = top - scrollHeight;

        // 如果图片固定位置
        if (isFixedPos) {
            // 这里需要计算图片在画布中的位置，因为position:fixed 是相对于 body 的，因此需要减去 canvas 的位置
            const mainCanvas = $("#luckysheetTableContent").get(0);
            const { x, y } = mainCanvas.getBoundingClientRect();

            // 如果图片是固定位置，则其一定会受到滚动条的影响，这需要兼容滚动
            const windowScrollWidth = $("#luckysheet-cell-main").scrollLeft();
            const windowScrollHeight = $("#luckysheet-cell-main").scrollTop();

            imageLeft = (fixedLeft - x - offsetLeft) * Store.zoomRatio - scrollWidth + windowScrollWidth;
            imageTop = (fixedTop - y - offsetTop) * Store.zoomRatio - scrollHeight + windowScrollHeight;
        }

        // 这里判定图片是否在打印区域内就不需要传递 scrollWidth, scrollHeight 了，因为是通过构建矩形宽高判定重叠面积实现的，
        // 打印区域的 left top 一定要等于 0 ，不然绘制会异常
        if (!inPrintArea({ ch_width, rh_height, left: imageLeft, top: imageTop, width, height })) continue;

        // 1. 处理图片绘制
        const handleImagePromise = (resolve) => {
            const imageElement = new Image();
            imageElement.src = src;

            imageElement.onerror = resolve;

            imageElement.onload = () => {
                ctx.save();
                ctx.scale(devicePixelRatio, devicePixelRatio);

                // 判断当前图片是否被裁剪
                // 宽高相等，偏移为0 则认为图片没有被裁剪，不然则被裁剪,裁剪后，直接通过 canvas 实现即可
                if (isCrop(imageID)) {
                    const sx = crop.offsetLeft * Store.zoomRatio;
                    const sy = crop.offsetTop * Store.zoomRatio;
                    const sw = crop.width * Store.zoomRatio;
                    const sh = crop.height * Store.zoomRatio;
                    const dx = imageLeft;
                    const dy = imageTop;
                    const dw = crop.width * Store.zoomRatio;
                    const dh = crop.height * Store.zoomRatio;
                    // 八个形参实现裁剪功能
                    ctx.drawImage(imageElement, sx, sy, sw, sh, dx, dy, dw, dh);
                } else {
                    const dx = imageLeft;
                    const dy = imageTop;
                    const dw = width; // 需要这两个参数实现缩放
                    const dh = height; // 需要这两个参数实现缩放
                    // 四个参数直接绘制图片
                    ctx.drawImage(imageElement, dx, dy, dw, dh);
                }
                // 绘制边框 border.width  是边框宽度
                if (border.width) {
                    const x = imageLeft;
                    const y = imageTop;
                    const w = width;
                    const h = height;
                    drawImageBorder(ctx, x, y, w, h, border);
                }

                ctx.restore();

                resolve();
            };
        };

        // 2. 创建异步函数
        const imagePromise = new Promise(handleImagePromise);

        // 3. 添加到Promise数组中
        imagePromises.push(imagePromise);
    }

    // 等待所有图片加载完成
    return await Promise.all(imagePromises);
}

/**
 * @description 获取图片当前的真实宽高
 * @param {*} id 图片id
 */
function getImageRealWH(id) {
    // 最快的就是获取真实的DOM宽高
    const $imgDom = $("#" + id);
    if (!$imgDom.length) return { width: 0, height: 0 };
    const width = $imgDom.width() || 0;
    const height = $imgDom.height() || 0;
    return { width, height };
}

/**
 * @description 获取图片当前的真实位置
 * @param {*} id 图片id
 */
function getImageRealPosition(id) {
    // 最快的就是获取真实的DOM宽高
    const $imgDom = $("#" + id);
    if (!$imgDom.length) return { left: 0, top: 0 };
    // 这里应该取 style 上的属性，而不是取真实的位置，因为滚动条会影响其位置关系
    const left = parseInt($imgDom.css("left")) || 0;
    const top = parseInt($imgDom.css("top")) || 0;
    return { left, top };
}

/**
 * @description 辅助函数 - 判断图片是否被裁剪
 * @param {*} id
 * @returns {boolean}
 */
function isCrop(id) {
    const images = Store.luckysheetfile[getSheetIndex(Store.currentSheetIndex)]?.images || {};
    const image = images[id] || {};
    if (!image) return false;

    // 解析其 default 属性
    const { default: defaultInfo } = image;

    // 获取其真实宽高
    const { width, height } = getImageRealWH(id);
    return width !== defaultInfo.width || height !== defaultInfo.height;
}

/**
 * @description 判定传入的图片是否在当前打印范围内
 * 这里提供两种备选方案： strict
 * 1. 非严格模式：只要图片与打印区域有重叠部分，则视为需要打印图片
 * 2. 严格模式下：则需要设定为图片范围完全在打印区域内
 */
function inPrintArea({ ch_width, rh_height, left, top, width, height, strict = false }) {
    // 图片矩形区域
    const imgLeft = left;
    const imgTop = top;
    const imgRight = left + width;
    const imgBottom = top + height;

    // 打印区域矩形
    const printLeft = 0;
    const printTop = 0;
    const printRight = 0 + ch_width;
    const printBottom = 0 + rh_height;

    // 检查是否完全在打印区域内（完全重叠）
    const isFullyContained = imgLeft >= printLeft && imgTop >= printTop && imgRight <= printRight && imgBottom <= printBottom;

    // 检查是否有重叠（相交）
    const hasIntersection = imgLeft < printRight && imgRight > printLeft && imgTop < printBottom && imgBottom > printTop;

    // 非严格模式：只要有重叠部分就认为在打印区域内
    // 严格模式：需要图片完全在打印区域内
    const isInPrintArea = strict ? isFullyContained : hasIntersection;

    // console.log("图片是否在打印范围内:", isInPrintArea);
    return isInPrintArea;
}

/**
 * @description 工具函数 - 绘制图片边框
 * @param {*} ctx
 * @param {*} x
 * @param {*} y
 * @param {*} w
 * @param {*} h
 * @param {*} border
 */
function drawImageBorder(ctx, x, y, w, h, border) {
    ctx.save();
    // style: 'solid' | 'dashed' | 'dotted' | 'double'
    const dashStyle = {
        solid: [],
        dashed: [5, 5],
        dotted: [1, 5],
        // double: [5, 5, 5, 5], // 目前双线的效果不佳，暂时不实现
    };

    const { width, style, color } = border;
    ctx.strokeStyle = color;
    ctx.lineWidth = width;
    ctx.beginPath();
    ctx.setLineDash(dashStyle[style] || []);
    ctx.moveTo(x, y);
    ctx.lineTo(x + w, y);
    ctx.lineTo(x + w, y + h);
    ctx.lineTo(x, y + h);
    ctx.closePath();
    ctx.stroke();
    ctx.restore();
}

/**
 * @description 初始化预览模式按钮事件 .luckysheet-print-viewBtn.click()
 */
function printInitial() {
    let container = luckysheetConfigsetting.container;
    $("#" + container)
        .find(".luckysheet-print-viewBtn")
        .click(function () {
            switchViewBtn($(this));
        });
}

/**
 * @description 切换视图
 */
function switchViewBtn($t) {
    let $viewList = $t.parent(),
        preType = $viewList.find("luckysheet-print-viewBtn-active").attr("type");
    if ($t.attr("type") == preType) {
        return;
    }

    let curType = $t.attr("type");
    if (curType != null) {
        handleViewChange(curType, preType);
    } else {
        return;
    }

    $t.parent().find(".luckysheet-print-viewBtn").removeClass("luckysheet-print-viewBtn-active");
    $t.addClass("luckysheet-print-viewBtn-active");
}

/**
 * @description 用户打印指定页码时，需要弹窗进行输入
 */
function openInputPageDialog(callback) {
    // 如果存在，则先删除
    $("#luckysheet-modal-dialog-mask")?.hide();
    $("#luckysheet-print-page-dialog")?.remove();

    // 使用 modelHTML 创建模态框
    $("body").append(
        replaceHtml(modelHTML, {
            id: "luckysheet-print-page-dialog",
            addclass: "luckysheet-print-page-dialog",
            title: "打印指定页码",
            content: `<input type="text" placeholder="请输入页码,多个页码用逗号分割">`,
            botton:
                '<button class="btn btn-primary luckysheet-model-confirm-btn">' +
                "确认" +
                "</button>" +
                '<button class="btn btn-default luckysheet-model-close-btn">' +
                "取消" +
                "</button>",
            style: "z-index:100003",
        }),
    );

    // 居中
    let $t = $("#luckysheet-print-page-dialog").find(".luckysheet-modal-dialog-content").css("min-width", 260).end(),
        myh = $t.outerHeight(),
        myw = $t.outerWidth();
    let winw = $(window).width(),
        winh = $(window).height();
    let scrollLeft = $(document).scrollLeft(),
        scrollTop = $(document).scrollTop();

    $("#luckysheet-print-page-dialog")
        .css({ left: (winw + scrollLeft - myw) / 2, top: (winh + scrollTop - myh) / 3 })
        .show();

    setTimeout(() => {
        // 自动获取焦点
        $("#luckysheet-print-page-dialog input").focus();
    }, 10);

    // 关闭模态框
    function closeDialog() {
        $("#luckysheet-modal-dialog-mask")?.hide();
        $("#luckysheet-print-page-dialog")?.remove();
    }

    // 确认按钮
    $("#luckysheet-print-page-dialog .luckysheet-modal-dialog-buttons .luckysheet-model-confirm-btn").click(function () {
        const page = $("#luckysheet-print-page-dialog input").val().trim();
        // 将二维数组转为一维数组
        const pageArray = page
            .split(",")
            .map((i) => i.split("，"))
            .reduce((pre, cur) => {
                return pre.concat(cur);
            }, [])
            .map(Number);
        if (callback && typeof callback === "function") callback(pageArray);

        // 关闭模态框
        closeDialog();
    });
}

/**
 * @description 调用 Window 内置方法进行打印，这里传入的参数是针对打印边框做优化使用
 * @param { Array } imageList
 * @param { Object } printParams
 *
 */
function printWindow(imageList, printParams) {
    if (!imageList || !imageList.length) return;

    // 创建 iframe 容器
    const printIframe = document.createElement("iframe");
    printIframe.classList = "print-preview-iframe";
    $("body").append(printIframe);

    // 获取 iframe 的 document 对象
    const iframeDocument = printIframe.contentDocument;
    if (iframeDocument == null) return;

    // 定义打印样式 @print
    initPrintStyle(iframeDocument, printParams?.pageMargin || {});

    // 创建 print-box 容器,内部创建 print-page 实现页码分割
    const printBox = document.createElement("div");
    printBox.className = "print-box";
    printBox.style.cssText = `
		position: absolute;
		top: 0;
		left: 0;
		box-sizing: border-box;
		background: white;
		border: solid transparent 0px;
		z-index: 9999;
		padding: 1px;
	`;

    // 根据 imageList 创建 print-page
    createPrintPage(printBox, imageList);

    iframeDocument.body.append(printBox);

    /** 实现打印水印 */
    createPrintWatermark(iframeDocument);

    // 执行打印
    setTimeout(() => {
        printIframe.contentWindow.print();
        printIframe.remove();
    }, 100);
}

/**
 * @description 打印预览 - 根据传入的图片，创建 print-page
 */
function createPrintPage(printBox, imageList) {
    // 清空容器
    printBox.innerHTML = "";

    // 获取A4纸张尺寸
    const { paperWidth, paperHeight } = getPaperSize();

    // 为每张图片创建一个打印页面容器
    imageList.forEach((imgSrc, index) => {
        // 创建页面容器
        const pageDiv = document.createElement("div");
        pageDiv.className = "print-page";
        pageDiv.style.cssText = `
            width: ${paperWidth}px;
            height: ${paperHeight}px;
            margin: 0 auto;
            box-sizing: border-box;
            border: 1px solid transparent;
            page-break-after: ${index < imageList.length - 1 ? "always" : "auto"};
            background: white;
            display: flex;
            align-items: flex-start;
            justify-content: center;
        `;

        // 创建图片元素
        const img = document.createElement("img");
        img.src = imgSrc;
        img.style.cssText = `
            width: 100%;
            max-height: 100%;
            display: block;
        `;

        // 添加图片到页面容器
        pageDiv.appendChild(img);
        printBox.appendChild(pageDiv);
    });
}

/**
 * @description 打印预览 - 实现打印水印
 */
function createPrintWatermark(iframeDocument) {
    // 1. 获取内部的 print-box 元素
    const printBox = iframeDocument.querySelector(".print-box");
    const { clientWidth, clientHeight } = printBox;

    // 2. 创建 canvas
    const canvas = iframeDocument.createElement("canvas");
    canvas.width = clientWidth;
    canvas.height = clientHeight;
    canvas.style.cssText = `
		position: absolute;
		top: 0;
		left: 0;
		z-index: 10000;
		width: ${clientWidth}px;
		height: ${clientHeight}px;
	`;
    iframeDocument.body.append(canvas);

    // 3. 绘制水印
    const ctx = canvas.getContext("2d");

    // 保存画布状态
    ctx.save();

    // 设置水印文本样式
    ctx.fillStyle = "rgba(0,0,0,0.04)";
    ctx.font = "bold 20px Arial";

    // 获取文本尺寸
    const text = "Luckysheet-crdt";
    const textWidth = ctx.measureText(text).width;
    const textHeight = 20; // 大致的文本高度

    // 计算对角线长度和旋转后的占用空间
    const diagonal = Math.sqrt(clientWidth * clientWidth + clientHeight * clientHeight);
    const watermarkSpacing = Math.max(textWidth, textHeight) * 1.5; // 水印间距

    // 旋转整个画布 -45度
    ctx.translate(clientWidth / 2, clientHeight / 2);
    ctx.rotate(-Math.PI / 4);

    // 在旋转后的坐标系中绘制平铺的水印
    for (let x = -diagonal; x < diagonal; x += watermarkSpacing) {
        for (let y = -diagonal; y < diagonal; y += watermarkSpacing * 0.5) {
            ctx.fillText(text, x, y);
        }
    }

    // 恢复画布状态
    ctx.restore();
}

/**
 * @description 打印预览 - 打印样式,可以在这里设定一些打印相干参数 是否打印网格线|调整页面边距|打印缩放等
 */
function initPrintStyle(iframeDocument, pageMargin = {}) {
    // 这里只取 pageMargin 即可
    const { left = 0, top = 0, right = 0, bottom = 0 } = pageMargin;

    const style = document.createElement("style");
    style.media = "print";

    // 设置A4纸张尺寸
    style.innerText = `
        @page {
            size: A4;
            margin: ${left}mm ${top}mm ${right}mm ${bottom}mm;
        }
        body {
            margin: 0;
            padding: 0;
        }
        .print-box {
            margin: 0;
            padding: 0;
        }
        .print-page {
            page-break-inside: avoid;
            page-break-after: auto;
        }
        .print-page:last-child {
            page-break-after: avoid;
        }
    `;

    iframeDocument.head.append(style);
}

export {
    getPrevieDialogContent,
    getOneMmsPx,
    getPaperSize,
    patchImageContent,
    drawPrintLineAndPaper,
    closeSelection,
    openSelection,
    calculatePageRanges,
    getScreenshotByRange,
    switchViewBtn,
    printInitial,
    openInputPageDialog,
    getScreenshotByPageNum,
    printWindow,
    getScreenshotBySheet,
};
